export const tableConfig = {
  pageIndex: 0,
  pageSize: 10,
} as const;
